import { render, staticRenderFns } from "./TextAttr.vue?vue&type=template&id=67c76290&scoped=true"
import script from "./TextAttr.vue?vue&type=script&lang=js"
export * from "./TextAttr.vue?vue&type=script&lang=js"
import style0 from "./TextAttr.vue?vue&type=style&index=0&id=67c76290&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c76290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67c76290')) {
      api.createRecord('67c76290', component.options)
    } else {
      api.reload('67c76290', component.options)
    }
    module.hot.accept("./TextAttr.vue?vue&type=template&id=67c76290&scoped=true", function () {
      api.rerender('67c76290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/components/TextAttr.vue"
export default component.exports